import React from "react";
import "./AcceptanceStatusStackBar.css";

const AcceptanceStatusStackBar = ({ segments, trackClassName, ariaLabel }) => (
  <div
    className={["acceptance-status-stack-track", trackClassName].filter(Boolean).join(" ")}
    role="group"
    aria-label={ariaLabel}
  >
    {segments && !segments.hasAny ? <div className="acceptance-status-stack-empty" aria-hidden /> : null}
    {segments && segments.hasAny ? (
      <div className="acceptance-status-stack">
        {segments.a > 0 ? (
          <div
            className="acceptance-status-stack-segment acceptance-status-stack-segment--accepted"
            style={{ flexGrow: segments.a, flexShrink: 0, flexBasis: 0 }}
            title={`${segments.a} accepted`}
          />
        ) : null}
        {segments.p > 0 ? (
          <div
            className="acceptance-status-stack-segment acceptance-status-stack-segment--pending"
            style={{ flexGrow: segments.p, flexShrink: 0, flexBasis: 0 }}
            title={`${segments.p} pending`}
          />
        ) : null}
        {segments.r > 0 ? (
          <div
            className="acceptance-status-stack-segment acceptance-status-stack-segment--rejected"
            style={{ flexGrow: segments.r, flexShrink: 0, flexBasis: 0 }}
            title={`${segments.r} rejected`}
          />
        ) : null}
        {segments.remainder > 0 ? (
          <div
            className="acceptance-status-stack-segment acceptance-status-stack-segment--remainder"
            style={{ flexGrow: segments.remainder, flexShrink: 0, flexBasis: 0 }}
            title={`${segments.remainder} not in accepted, pending, or rejected breakdown`}
          />
        ) : null}
      </div>
    ) : null}
  </div>
);

AcceptanceStatusStackBar.defaultProps = {
  trackClassName: "",
  ariaLabel: undefined,
};

export default AcceptanceStatusStackBar;
